module.exports = __webpack_public_path__ + "img/map.1148a41a.svg";